import { render, staticRenderFns } from "./Ewallet.vue?vue&type=template&id=b398d758&"
import script from "./Ewallet.vue?vue&type=script&lang=js&"
export * from "./Ewallet.vue?vue&type=script&lang=js&"
import style0 from "./Ewallet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports